import { isValidObjectId } from '@/utils/validation';

/**
 * Split a multi-value search input into trimmed, non-empty tokens.
 * Accepts comma- or semicolon-separated values (e.g. "abc, def; ghi").
 */
export const splitSearchValue = (value: string): string[] => {
  if (!value) return [];
  return value
    .split(/[,;]/)
    .map(v => v.trim())
    .filter(v => v.length > 0);
};

/**
 * Partition a Case-ID search box value into the two fields the case-record
 * endpoints accept: valid Mongo ObjectIds go to `case_record_ids`, everything
 * else is treated as a human-readable case code (`case_codes`). Each side is
 * `undefined` when it has no values, so the result can be spread straight into
 * a request without setting empty arrays.
 *
 * Shared by the per-program `CasesContainer` and the org-wide
 * `Tier1CasesContainer` so both treat case codes identically.
 */
export const partitionCaseIdSearch = (
  value: string,
): { caseRecordIds?: string[]; caseCodes?: string[] } => {
  const values = splitSearchValue(value);
  const objectIds = values.filter(isValidObjectId);
  const codes = values.filter(v => !isValidObjectId(v));
  return {
    caseRecordIds: objectIds.length > 0 ? objectIds : undefined,
    caseCodes: codes.length > 0 ? codes : undefined,
  };
};
